(() => {
  'use strict';
  const root = document.body.dataset.root || '/';
  const endpoint = name => `${root.replace(/\/$/, '')}/${name}`;
  let cartBusy = false;
  let cartTrigger;
  const drawer = () => document.getElementById('CartDrawer');
  const announce = message => { document.getElementById('StoreStatus').textContent = message; };
  function openCart(trigger) {
    cartTrigger = trigger || document.activeElement;
    if (!drawer().open) drawer().showModal();
    document.body.classList.add('cart-open');
  }
  function closeCart() { drawer().close(); }
  drawer()?.addEventListener('close', () => { document.body.classList.remove('cart-open'); cartTrigger?.focus(); });
  drawer()?.addEventListener('click', event => { if (event.target === drawer()) closeCart(); });
  function paintCart(html) {
    if (!html) return false;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const content = doc.querySelector('[data-cart-content]');
    if (!content) return false;
    document.querySelectorAll('[data-cart-content]').forEach(target => {
      const copy = content.cloneNode(true);
      if (!target.closest('dialog')) {
        const heading = copy.querySelector('.cart-heading h2');
        const title = document.createElement('h1');
        title.id = 'FullCartTitle'; title.tabIndex = -1;
        title.innerHTML = heading.innerHTML; heading.replaceWith(title);
      }
      target.replaceWith(copy);
    });
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = content.dataset.count; });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: Number(content.dataset.count) } }));
    return true;
  }
  async function refreshCart() {
    const response = await fetch(endpoint('?section_id=s-cart'), { headers: { Accept: 'text/html' } });
    if (!response.ok || !paintCart(await response.text())) throw new Error('Your bag updated. Open the full bag to review it.');
  }
  async function cartRequest(name, data) {
    const response = await fetch(endpoint(name), { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || 'Unable to update your bag. Please try again.');
    if (!paintCart(result.sections?.['s-cart'])) await refreshCart();
    return result;
  }
  document.addEventListener('click', async event => {
    const sizeGuide = event.target.closest('[data-size-guide]');
    if (sizeGuide) { const details = document.getElementById(sizeGuide.hash.slice(1)); if (details) details.open = true; }
    const opener = event.target.closest('[data-cart-open]');
    if (opener) { event.preventDefault(); openCart(opener); return; }
    if (event.target.closest('[data-cart-close]')) { closeCart(); return; }
    const qty = event.target.closest('[data-quantity]');
    if (!qty || cartBusy) return;
    const key = qty.closest('[data-line-key]').dataset.lineKey;
    const quantity = Number(qty.dataset.quantity);
    cartBusy = true;
    document.querySelectorAll('[data-quantity], .cart-checkout button').forEach(el => { el.disabled = true; });
    try {
      await cartRequest('cart/change.js', { id: key, quantity, sections: ['s-cart'], sections_url: location.pathname });
      announce('Bag updated.');
      const replacement = [...document.querySelectorAll('[data-line-key]')].find(el => el.dataset.lineKey === key && el.closest('dialog') === (drawer().open ? drawer() : null));
      (replacement?.querySelector('[data-quantity]') || document.querySelector(drawer().open ? '#CartDrawer [data-cart-close]' : '.full-cart .cart-heading h1'))?.focus();
    } catch (error) { document.querySelectorAll('[data-cart-error]').forEach(el => { el.textContent = error.message; }); }
    finally { cartBusy = false; document.querySelectorAll('[data-quantity], .cart-checkout button').forEach(el => { el.disabled = false; }); }
  });
  function initProduct(product) {
    if (product.dataset.initialized) return;
    product.dataset.initialized = 'true';
    const variants = JSON.parse(product.querySelector('[data-variants]').textContent);
    const form = product.querySelector('[data-product-form]');
    const groups = [...product.querySelectorAll('[data-option-index]')];
    const variantInput = form.querySelector('[data-variant-id]');
    const add = form.querySelector('[data-add]');
    const addLabel = form.querySelector('[data-add-label]');
    const error = form.querySelector('[data-product-error]');
    const isPreorder = variant => product.dataset.preorder === 'true' && variant?.title.includes('Coal');
    if (product.dataset.hasSelection !== 'true') groups.forEach(group => {
      const legend = group.querySelector('legend').firstChild.textContent.toLowerCase();
      if (legend.includes('size') || (!legend.includes('color') && groups.length > 1)) group.querySelectorAll('input').forEach(input => { input.checked = false; });
    });
    function showMedia(id) {
      if (!id || !product.querySelector(`[data-media-id="${id}"]`)) return;
      product.querySelectorAll('[data-media-id]').forEach(el => { el.hidden = el.dataset.mediaId !== String(id); el.querySelectorAll('video').forEach(video => video.pause()); });
      product.querySelectorAll('[data-media-target]').forEach(el => { el.setAttribute('aria-pressed', String(el.dataset.mediaTarget === String(id))); });
    }
    let chosen;
    function updateVariant(updateUrl = true) {
      const options = groups.map(group => group.querySelector('input:checked')?.value);
      chosen = variants.find(variant => variant.options.every((value, index) => value === options[index]));
      groups.forEach((group, index) => {
        group.querySelector('[data-option-label]').textContent = options[index] || 'Select';
        group.querySelectorAll('input').forEach(input => {
          const possible = variants.some(variant => variant.available && variant.options[index] === input.value && options.every((value, i) => i === index || !value || variant.options[i] === value));
          input.closest('label').classList.toggle('unavailable', !possible);
          input.setAttribute('aria-label', input.value + (possible ? '' : ' — unavailable with current options'));
        });
      });
      const incomplete = options.some(value => !value);
      add.disabled = !chosen?.available;
      variantInput.disabled = !chosen;
      if (chosen) variantInput.value = String(chosen.id);
      addLabel.textContent = incomplete ? 'Choose your options' : !chosen ? 'Unavailable combination' : !chosen.available ? 'Sold out' : isPreorder(chosen) ? 'Preorder — Add to bag' : 'Add to bag';
      const sticky = product.querySelector('[data-sticky-buy]');
      sticky.textContent = chosen?.available ? (isPreorder(chosen) ? 'Preorder ↑' : 'Add to bag ↑') : 'Choose options ↑';
      if (chosen) {
        const price = product.querySelector('[data-product-price]');
        price.textContent = chosen.price;
        if (chosen.compare) { const compare = document.createElement('s'); compare.textContent = chosen.compare; price.append(' ', compare); }
        showMedia(chosen.media);
        if (updateUrl) { const url = new URL(location.href); url.searchParams.set('variant', chosen.id); history.replaceState({}, '', url); }
      }
      const notice = product.querySelector('[data-fulfillment]');
      if (notice) {
        const coal = options.some(value => value?.includes('Coal'));
        notice.querySelector('strong').textContent = coal ? 'Rebirth zip up: Coal preorder' : 'Rebirth zip up: Sand & Lavender premade';
        notice.querySelector('span').textContent = coal ? 'The Coal zip up ships in 5–8 weeks. Sand and Lavender zip ups ship in 1–3 days.' : 'These zip ups ship in 1–3 days. Coal zip ups ship in 5–8 weeks.';
      }
    }
    groups.forEach(group => group.addEventListener('change', () => { error.textContent = ''; updateVariant(); }));
    product.querySelectorAll('[data-media-target]').forEach(button => button.addEventListener('click', () => showMedia(button.dataset.mediaTarget)));
    product.querySelector('[data-sticky-buy]').addEventListener('click', () => {
      if (chosen?.available && !cartBusy) form.requestSubmit(add);
      else { form.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' }); groups.find(group => !group.querySelector('input:checked'))?.querySelector('input')?.focus(); }
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!chosen?.available || cartBusy) return;
      cartBusy = true; add.disabled = true; add.setAttribute('aria-busy', 'true'); addLabel.textContent = 'Adding…'; error.textContent = '';
      try {
        const data = new FormData(form);
        data.append('sections', 's-cart'); data.append('sections_url', location.pathname);
        const response = await fetch(endpoint('cart/add.js'), { method: 'POST', headers: { Accept: 'application/json' }, body: data });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this option. Please try another size.');
        if (!paintCart(result.sections?.['s-cart'])) await refreshCart();
        announce('Added to your bag.'); openCart(add);
      } catch (problem) { error.textContent = problem.message + ' You can also open your bag to check its current contents.'; }
      finally { cartBusy = false; add.removeAttribute('aria-busy'); updateVariant(false); }
    });
    updateVariant(false);
  }
  document.querySelectorAll('[data-product]').forEach(initProduct);
  document.querySelectorAll('[data-address-country]').forEach(country => {
    country.value = country.dataset.default;
    const province = country.form.querySelector('[data-address-province]');
    const update = () => {
      const values = JSON.parse(country.selectedOptions[0]?.dataset.provinces || '[]');
      province.replaceChildren(...values.map(([value, label]) => new Option(label, value)));
      province.disabled = values.length === 0;
      province.hidden = values.length === 0;
      country.form.querySelector(`label[for="${province.id}"]`).hidden = values.length === 0;
      if (values.some(([value]) => value === province.dataset.default)) province.value = province.dataset.default;
    };
    country.addEventListener('change', update); update();
  });
  document.addEventListener('shopify:section:load', event => { event.target.querySelectorAll('[data-product]').forEach(initProduct); });
})();
